module.exports = __webpack_public_path__ + "static/media/select-seat.ab3dc917.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Booking/svg/select-seat.svg
// module id = 519
// module chunks = 0